module.exports = __webpack_public_path__ + "static/fonts/Campton-Bold.5cce0d5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Campton-Bold.ttf
// module id = 3hdi
// module chunks = 1